import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import Lottie from "lottie-react";

// Lottie animations
import verifyingAnimation from "./loading.json";
import successAnimation from "./verified.json";
import baseUrl from "../../config/baseUrl";

function EmailVerification() {
  const { user_id } = useParams();
  console.log(user_id);

  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      if (!user_id) {
        setStatus("error");
        setLoading(false);
        return;
      }
      try {
        const response = await axios.post(`${baseUrl}/verifyMerchant`, {
          user_id: user_id,
        });

        const newStatus =
          response.status === 200
            ? "success"
            : "error";

        setTimeout(() => {
          setStatus(newStatus);
          setLoading(false);
        }, 5000);
      } catch (error) {
        setTimeout(() => {
          setStatus("error");
          setLoading(false);
        }, 5000);
      }
    };

    verifyEmail();
  }, [user_id]);

  return (
    <Box sx={{ textAlign: "center", mt: 10 }}>
      {loading ? (
        <>
          <Box sx={{ width: 300, mx: "auto" }}>
            <Lottie animationData={verifyingAnimation} loop />
          </Box>
          <Typography
            variant="h6"
            mt={2}
            sx={{
              color: "#007bff",
              fontWeight: "bold",
              letterSpacing: "0.5px",
              fontSize: "1.2rem",
              animation: "pulse 1.8s infinite",
            }}
          >
            Verifying your email, please wait...
          </Typography>
        </>
      ) : status === "success" ? (
        <>
          <Box sx={{ width: 300, mx: "auto" }}>
            <Lottie animationData={successAnimation} loop={false} />
          </Box>
          <Typography
            variant="h5"
            mt={2}
            sx={{
              color: "green",
              fontWeight: "bold",
              letterSpacing: "0.5px",
              fontSize: "1.2rem",
              animation: "pulse 1.8s infinite",
            }}
          >
            Your email has been successfully verified!
          </Typography>
          <Box mt={3}>
            <a href="/DepositPortal" style={{ textDecoration: "none" }}>
            <button
                style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "5px",
                color: "white",
                fontWeight: "bold",
                fontSize: "14px",
                cursor: "pointer",
                }}
            >
                Go to Login
            </button>
            </a>
        </Box>
        </>
      ) : (
        <Typography variant="h5" color="red">
          ❌ Invalid or expired verification link.
        </Typography>
      )}
    </Box>
  );
}

export default EmailVerification;
